import { features } from '@/mocks/seoData';

export default function FeatureSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-heading font-medium md:font-semibold text-foreground-900 mb-3">
            Why Use Our <strong>Sugargoo Spreadsheet</strong>?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Our curated <strong>Sugargoo Spreadsheet</strong> resources save you time and help you discover 
            quality products with confidence.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="bg-background-100 rounded-lg p-6 border border-background-200/70 group hover:border-primary-200 transition-all duration-200"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 mb-4 group-hover:bg-primary-100 transition-colors">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-background-100 rounded-lg border border-background-200/70 overflow-hidden">
          <div className="px-6 py-5 border-b border-background-200/70">
            <h3 className="text-lg font-heading font-semibold text-foreground-900">
              <strong>Sugargoo Spreadsheet</strong> vs Traditional Searching
            </h3>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-background-200/50">
                  <th className="text-left px-6 py-3 font-semibold text-foreground-700 whitespace-nowrap">Feature</th>
                  <th className="text-left px-6 py-3 font-semibold text-foreground-700 whitespace-nowrap">Normal Searching</th>
                  <th className="text-left px-6 py-3 font-semibold text-primary-700 whitespace-nowrap">Sugargoo Spreadsheet</th>
                </tr>
              </thead>
              <tbody>
                {[
                  { feature: 'Product Discovery', normal: 'Slow', spreadsheet: 'Fast' },
                  { feature: 'Organization', normal: 'Poor', spreadsheet: 'Excellent' },
                  { feature: 'Product Categories', normal: 'Limited', spreadsheet: 'Structured' },
                  { feature: 'Beginner Friendly', normal: 'No', spreadsheet: 'Yes' },
                  { feature: 'Research Time', normal: 'High', spreadsheet: 'Low' },
                ].map((row) => (
                  <tr key={row.feature} className="border-b border-background-200/50 hover:bg-background-50/50 transition-colors">
                    <td className="px-6 py-3 font-medium text-foreground-800 whitespace-nowrap">{row.feature}</td>
                    <td className="px-6 py-3 text-foreground-600 whitespace-nowrap">{row.normal}</td>
                    <td className="px-6 py-3 text-primary-700 font-medium whitespace-nowrap">
                      <i className="ri-check-line mr-1 text-primary-500"></i>{row.spreadsheet}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}